export const UI_VERSION = "v5.0.39";
export const API_VERSION = "v0.2.57";